import React, { PureComponent as Component } from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import propTypes from 'prop-types';
import { perPageOptions } from '../../../constants/kickavenue';

const sortByOptions = [
  { value: 'updated_at', label: 'Last Updated' },
  { value: 'created_at', label: 'Created At' },
  { value: 'name', label: 'Name' }
];

const sortOrderOptions = [
  { value: 'asc', label: 'Ascending' },
  { value: 'desc', label: 'Descending' }
];

const activeOptions = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' }
];

export default class SortForm extends Component {
  render() {
    return (
      <Form inline className="form-filter">
        <FormGroup className="mb-2 mr-3">
          <Label className="mr-sm-3">Show</Label>
          <Input
            type="select"
            name="per_page"
            onChange={this.props.onInputChange}
            value={this.props.per_page}
          >
            {perPageOptions.map((option, i) => (
              <option value={option.value} key={i}>{option.label}</option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup className="mb-2 mr-3">
          <Label className="mr-sm-3">Sort By</Label>
          <Input
            type="select"
            name="sort_by"
            onChange={this.props.onInputChange}
            value={this.props.sort_by}
          >
            {sortByOptions.map((option, i) => (
              <option value={option.value} key={i}>{option.label}</option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup className="mb-2 mr-3">
          <Label className="mr-sm-3">Order</Label>
          <Input
            type="select"
            name="sort_order"
            onChange={this.props.onInputChange}
            value={this.props.sort_order}
          >
            {sortOrderOptions.map((option, i) => (
              <option value={option.value} key={i}>{option.label}</option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup className="mb-2 mr-3">
          <Label className="mr-sm-3">Parent Category</Label>
          <Input
            type="select"
            name="category_id"
            onChange={this.props.onInputChange}
            value={this.props.category_id}
          >
            <option value="">All</option>
            {this.props.categoryOptions.map((option, i) => (
              <option value={option.value} key={i}>{option.label}</option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup className="mb-2 mr-3">
          <Label className="mr-sm-3">Active</Label>
          <Input
            type="select"
            name="active"
            onChange={this.props.onInputChange}
            value={this.props.active}
          >
            {activeOptions.map((option, i) => (
              <option value={option.value} key={i}>{option.label}</option>
            ))}
          </Input>
        </FormGroup>
      </Form>
    );
  }
}

SortForm.propTypes = {
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort_by: propTypes.string,
  sort_order: propTypes.string,
  category_id: propTypes.oneOfType([propTypes.number, propTypes.string]),
  active: propTypes.string,
  categoryOptions: propTypes.array,
  onInputChange: propTypes.func.isRequired
};

SortForm.defaultProps = {
  per_page: 15,
  sort_by: 'updated_at',
  sort_order: 'desc',
  category_id: '',
  active: '',
  categoryOptions: []
};
